"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BombardmentAbilityHandler = exports.BombardmentActorAbilityFactory = exports.BombardmentAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Burning_1 = require("../../core/effects/core/Burning");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
class BombardmentAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Bombardment;
        this.__typeName = "Bombardment";
    }
}
exports.BombardmentAbilityArgs = BombardmentAbilityArgs;
let BombardmentActorAbilityFactory = class BombardmentActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Bombardment", "AllEnemies", 4);
    }
};
BombardmentActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Bombardment")
], BombardmentActorAbilityFactory);
exports.BombardmentActorAbilityFactory = BombardmentActorAbilityFactory;
let BombardmentAbilityHandler = class BombardmentAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyMultiAttack({
            attackerId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            onDamage(sequence, target, _attack, damages) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: target.targetId,
                    sequence,
                    duration: Duration_1.Duration.Ticks(8),
                    effect: new Burning_1.BurningEffectArgs("Power", 10)
                });
            },
            sequence,
            targets: enemies.map((targetId, i) => ({
                targetId,
                jitter: (0, Random_1.random)(25, 75),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 60),
                    AbilityDamage_1.AbilityDamage.Power("Fire", 60)
                ],
            })),
            onHitOrMiss: (sequence, { targetId }, { hit }) => {
                sequence.push(new core_1.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                    : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "CannonBallExplosion"));
            },
        });
    }
};
BombardmentAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Bombardment)
], BombardmentAbilityHandler);
exports.BombardmentAbilityHandler = BombardmentAbilityHandler;
